var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreateProposal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.48975 4.67786H5.19548C4.83805 4.67786 4.54834 4.97165 4.54834 5.33411V6.64661C4.54834 7.00906 4.83805 7.30286 5.19548 7.30286H6.48975C6.84717 7.30286 7.13688 7.00906 7.13688 6.64661V5.33411C7.13688 4.97165 6.84717 4.67786 6.48975 4.67786Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.48975 9.27161H5.19548C4.83805 9.27161 4.54834 9.5654 4.54834 9.92786V11.2404C4.54834 11.6028 4.83805 11.8966 5.19548 11.8966H6.48975C6.84717 11.8966 7.13688 11.6028 7.13688 11.2404V9.92786C7.13688 9.5654 6.84717 9.27161 6.48975 9.27161Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.48975 13.8654H5.19548C4.83805 13.8654 4.54834 14.1592 4.54834 14.5216V15.8341C4.54834 16.1966 4.83805 16.4904 5.19548 16.4904H6.48975C6.84717 16.4904 7.13688 16.1966 7.13688 15.8341V14.5216C7.13688 14.1592 6.84717 13.8654 6.48975 13.8654Z",
    fill: "current"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1968 5.33411H8.43115V6.64661H16.1968V5.33411Z",
    fill: "current"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7969 9.92773H8.43115V11.2402H13.7969V9.92773Z",
    fill: "current"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5485 0.0841064H16.1969C18.6988 0.0841064 20.7269 2.14079 20.7269 4.67786V11.2413H19.4326V4.67786C19.4326 2.86566 17.984 1.39661 16.1969 1.39661H4.5485C2.76148 1.39661 1.31283 2.86566 1.31283 4.67786V16.4904C1.31283 18.3026 2.76148 19.7716 4.5485 19.7716H12.5967V21.0841H4.5485C2.04668 21.0841 0.0185547 19.0274 0.0185547 16.4904V4.67786C0.0185547 2.14079 2.04668 0.0841064 4.5485 0.0841064Z",
    fill: "current"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3281 12.0057H15.4571V15.6045H11.8584V17.4755H15.4571V21.0742H17.3281V17.4755H20.9269V15.6045H17.3281V12.0057Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateProposal);
export default __webpack_public_path__ + "static/media/CreateProposal.b292e5b2.svg";
export { ForwardRef as ReactComponent };